import React from "react";

export const InsuranceButtonElement = ({
  insuranceButtonIcon,
  insuranceButtonTitle,
  secondaryButtonTitle,
  secondaryButtonTitle2,
  showGlowingDot = false,
  showGlowingDot2 = false,
  onClick = () => {},
}) => {
  return (
    <div
      className="col-sm-6 col-md-2 insurance-button-container"
      style={{ width: "16.667%" }}
      onClick={onClick}
    >
      <div
        className="insurance-button d-flex justify-content-center align-items-center clickable "
        style={{
          height: "11.8rem",
          borderRadius: "20px",
          backgroundColor: "white",
        }}
      >
        <div className="insurance-button-content">
          <div className="text-center">{insuranceButtonIcon}</div>
          <div
            className="text-center inter-semi-bold title"
            style={{
              fontSize: "1.25rem",
              marginTop: "1.1625rem",
              color: "#199B8B",
            }}
          >
            {insuranceButtonTitle}
          </div>
          {secondaryButtonTitle && (
            <>
              <h6 className="text-center" style={{ color: "#000000" }}>
                {secondaryButtonTitle}
                {showGlowingDot && <span className="glowing-dot"></span>}
              </h6>
            </>
          )}
          {secondaryButtonTitle2 && (
            <>
              <h6 className="text-center" style={{ color: "#000000" }}>
                {secondaryButtonTitle2}
                {showGlowingDot2 && <span className="glowing-dot"></span>}
              </h6>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
